export default {
      id: "question-solid-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#question-solid",
      toString: function () {
        return this.url;
      }
    }